import { render, staticRenderFns } from "./UiMiniCrud.vue?vue&type=template&id=1b3c2723&"
import script from "./UiMiniCrud.vue?vue&type=script&lang=js&"
export * from "./UiMiniCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports